import { DeploymentContext } from './context';

export const useDeploymentContext = () => DeploymentContext.hook();
